module.exports = __webpack_public_path__ + "static/media/external-link-alt-hover.48f4f10f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/external-link-alt-hover.svg
// module id = 305
// module chunks = 0